/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GET_ASSET_DETAIL } from "../pages/AssetDetail/graphql/asset-detail.query";
import { UPDATE_ASSET_DETAIL ,UPDATE_DUPLICATE_ASSET} from "../pages/AssetDetail/graphql/edit-asset.mutation";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { toast } from "react-hot-toast";
import {SOUND ,VIDEO} from "../assets"
import {
    LIST_ASSET_FIELDS,
    LIST_ASSET_FORM_DATA,
    SHOWCASE_ASSET_FORM_DATA,
    SHOWCASE_ASSET_FIELDS,
    LIST_ASSET_FIELDS_FIAT
} from "./config/get-categories-form";
import {LOCK_ON_TX_SUCCESS} from "../pages/AssetDetail/graphql/lock-ontx-success.mutation";
import { humanize } from "uno-js";
import {
    LIST_ASSET_IN_CRYPTO,
    LIST_ASSET_IN_FIAT,
    SEND_SIGNED_OBJ,
    GET_ASSET_VOUCHER,
} from "../pages/AssetDetail/graphql/list-asset.mutation";
import {SELF_TRANSFER} from "../pages/AssetDetail/graphql/self-transfer.mutation";
import { SHOWCASE_ASSET } from "../pages/AssetDetail/graphql/showcase-asset.mutation";
import { GET_STORES } from "../pages/AssetDetail/graphql/get-stores.query";
import { GET_STORES_WITH_ID } from "../pages/AssetDetail/graphql/get-stores-with-storeID.query";
import {SIGN_VOUCHER_MESSAGE} from "./config/list-asset-individual-data";
import {StorageModule} from "@vlinder-web/storage-module-react";
import {getErrorMessage} from "../utils/error.message";
const MODULE_NAME = "AssetDetailService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

interface IProps{
    imageServer:any
}

export class AssetDetailService {
    private static instance: AssetDetailService;
    private vapp: VApplication;
    private imageServer;
    private fiatEnabled;
    private payEnabled;
    private payProvider;
    private termsURL: string;
    private constructor(props: IProps | any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL= props?.termsURL
        this.imageServer = props?.imageServer;
        this.fiatEnabled = props?.fiatEnabled;
        this.payEnabled = props?.payEnabled;
        this.payProvider = props?.payProvider;
    }
    public static getInstance(props: IProps | any = {}): AssetDetailService {
        if (!AssetDetailService.instance) {
            AssetDetailService.instance = new AssetDetailService(props);
        }
        return AssetDetailService.instance;
    }

    _getInfoButtons(data: any) {
        let _actionButtons: any = [];
        // if(resData.viewInIpfs){
        //     _actionButtons.push({
        //         title:"View on Ipfs",
        //         link:resData?.viewInIpfs
        //     })
        // }
        if (data ==="illegitimate_duplicate") {
            _actionButtons.push({
                key: "editDuplicate",
                title: "Update Primary Asset",
               
            });
        } else if(data === "created"){
            _actionButtons.push({
                key: "edit",
                title: "Edit",
            });
        }
        return _actionButtons;
    }

    _getActionButtons(data: any) {
        const _payment = AssetDetailService?.getInstance();
        const storageService = StorageModule.getInstance();
        const fiatEnabled = storageService.get("fiatEnabled", "session");
        const payProvider = storageService.get("payProvider", "session");
        console.log('payment enabled', this.payEnabled?.razorpay);
        let _fiatButton = [];
        if(payProvider === 'razorpay' && !_payment.payEnabled?.razorpay){
            _fiatButton.push({
                    key: "listInFiat",
                    title: "List in FIAT",
                    disabled: true,
                    tooltip: "Coming Soon"
            })
        }
        else if(payProvider === 'stripe' && !_payment?.payEnabled?.stripe){
            _fiatButton.push({
                    key: "listInFiat",
                    title: "List in FIAT",
                    disabled: true,
                    tooltip: "Coming Soon"
            })
        }
        else if((_payment?.payEnabled?.razorpay || _payment?.payEnabled?.stripe) && !fiatEnabled){
            _fiatButton.push({
                    key: "listInFiat",
                    title: "List in FIAT",
                    disabled: (!fiatEnabled) ? true : false,
                    tooltip: (!fiatEnabled )? "KYC Pending, please complete it in profile" : null
            })
        }
        else if((_payment?.payEnabled?.razorpay || _payment?.payEnabled?.stripe) && fiatEnabled){
            _fiatButton.push({
                key: "listInFiat",
                title: "List in FIAT",
                disabled: false,
        })
        }
        
        let _actionButtons: any = [];
        if (data ==="illegitimate_duplicate") {
            _actionButtons.push(
                {
                    key: "listInCrypto",
                    title: "List in Crypto",
                    disabled: true,
                    tooltip:"The verification of the asset in blockchain has failed as it is not unique.  You can change the asset image and proceed OR contact us at developer@vlinder.io "
                },
                {
                    key: "listInFiat",
                    title: "List in FIAT",
                    disabled: true,
                    tooltip:"The verification of the asset in blockchain has failed as it is not unique.  You can change the asset image and proceed OR contact us at developer@vlinder.io "
                },
                {
                    key: "listToShowcase",
                    title: "Display for Claim",
                    disabled: true,
                    tooltip:"The verification of the asset in blockchain has failed as it is not unique.  You can change the asset image and proceed OR contact us at developer@vlinder.io "
                },
                {
                    key: "showcase",
                    title: "Create Proof of Ownership",
                    disabled: true,
                    tooltip:"The verification of the asset in blockchain has failed as it is not unique.  You can change the asset image and proceed OR contact us at developer@vlinder.io "
                }
            );
        } else if(data === "cid_verification_pending") {
            _actionButtons.push(
                {
                    key: "listInCrypto",
                    title: "List in Crypto",
                    disabled: true,
                    tooltip:"Verification Pending"
                },
                {
                    key: "listInFiat",
                    title: "List in FIAT",
                    disabled: true,
                    tooltip:"Verification Pending"
                },
                {
                    key: "listToShowcase",
                    title: "Display for Claim",
                    disabled: true,
                    tooltip:"Verification Pending"
                },
                {
                    key: "showcase",
                    title: "Create Proof of Ownership",
                    disabled: true,
                    tooltip:"Verification Pending"
                }
            );
        } else{
            _actionButtons.push(
                {
                    key: "listInCrypto",
                    title: "List in Crypto",
                },
                ..._fiatButton,
                {
                    key: "listToShowcase",
                    title: "Display for Claim",
                },
                {
                    key: "showcase",
                    title: "Create Proof of Ownership",
                }
            );
        }

        return _actionButtons;
    }

    _getMeta(data: any[], digitalTwin: string) {
        let _meta = [];

        data?.map((item: any) => {
            _meta.push({
                key: item?.name,
                value: item?.val,
                disp_type: item?.disp_type,
            });
        });
        

        _meta.push({
            key: "Digital Twin",
            value: digitalTwin,
        });

        return _meta;
    }

    _getImages(data: any,media:any , type:string) {

        // const getassetsDetailService = ClaimAssetDetailService.getInstance();
        const imgUrl = data?.img;
        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
        const imgBBformat = imgUrl?.split('/');
        const ibbFormat = imgBBformat[imgBBformat.length-3]
     
        let _imgF;
         if(ibbFormat === "i.ibb.co"){
            // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
            _imgF = data?.img
         
         } 
         else {
            //  _imgF = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
            _imgF = data?.img
         }
         let _img;

         if(type === "audio"){
             _img = {
                original: data?.thumbnail?? SOUND,
                thumbnail: data?.thumbnail ?? SOUND,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                type: "audio",
                 embedUrl: data?.img,
            }
         }
         if(type === "video"){
            _img = {
               original: data?.thumbnail ?? VIDEO,
               thumbnail: data?.thumbnail ?? VIDEO,
               thumbnailHeight: "70",
               thumbnailClass: "image-thumb",
               type: "video",
                embedUrl: data?.img,
           }
        }
         if(type === "image"){
            _img = {
                original: _imgF,
                thumbnail: _imgF,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            }
         }
             
       
        let _data = media?.map((item: any) => {
            console.log("insidde",item)

            const imgUrl = item?.src;
            const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
            const imgBBformat = imgUrl?.split('/');
            const ibbFormat = imgBBformat[imgBBformat.length-3]
         
            let _imgM;
             if(ibbFormat === "i.ibb.co"){
                // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                _imgF = imgUrl
             
             } 
             else {
                //  _imgM = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
                _imgF = imgUrl
             }

            //    const uriType = ele?.uri.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0]
             const assetType = item?.type?.substring(0, item?.type?.indexOf('/'))
             // const assetType;
             let selectThumbnail;
             if(assetType === "video"){
                 selectThumbnail = VIDEO
             } else if( assetType === "audio"){
                 selectThumbnail = SOUND
             } else {
                 selectThumbnail = imgUrl
             }

            return {
                // ...item,
                original: selectThumbnail,
                    thumbnail: selectThumbnail,
                    thumbnailHeight: "70",
                    thumbnailClass: "image-thumb",
                    embedUrl: imgUrl,
                    type: assetType,
            };
        });
        console.log("IMG_DETAIL",[_img,..._data])

        let _images = [_img,..._data]
        return _images;

       
    }

    _getCreator(data:any, state:any, ipfs:any){
        console.log("creatrr",data, state , ipfs)
        if(state === "cid_verification_pending"){
            if(data){
                return{
                    userName: data.name,
                    userId: data.name,
                }
            }
      
            
        }else {
            if(data){
                return{
                    userName: data.name,
                    userId: data.name,
                    // link: "/swiss-timing",
                    authProofUrl:ipfs,
                }
            }
           
        }
    }

    async getCreatedAssetDetail(assetId: string, assetGroup: string) {
        // console.log("myAssetGroup", assetGroup);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId: assetId,
                        tokenGroup: assetGroup,
                        // storeId:"61739cbd2fbe0a187c984fb6"
                    },
                    fetchPolicy: "cache-first",
                });
                 console.log("inside service asset detail",res?.data?.getAsset)
                if (res) {
                    let _data = res?.data?.getAsset;
                    let _found = {
                        ..._data,
                        idx: _data?.idx,
                        title: _data?.title,
                        subtitle: _data?.subtitle,
                        tokenId: _data?.serialNo,
                        serialNo: _data?.serialNo,
                        tag: _data?.tag?.toUpperCase(),
                        category: _data?.tag?.toLowerCase(),
                        // price: _data?.price,
                        meta: this._getMeta(_data?.attrs, _data?.digitalTwin),
                        info: this._getInfoButtons(_data?.state),
                        createdBy: this._getCreator(_data?.creator, _data?.state, res?.data?.viewInIpfs),
                        ownedBy: {
                            userName: _data?.owner?.name,
                            userId: _data?.owner?.name,
                        },
                        type:_data?.type,
                        actions: this._getActionButtons(_data?.state),
                        images: this._getImages(_data, _data?.media, _data?.type),
                        nftProvenance: _data?.nftProvenance?.map(item => {
                            console.log("nftprov",item)
                            return ({
                                title: item?.title,
                                profile: {
                                    // userName: item?.from?.name ?? item?.to?.name ,
                                    userName: item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.name : item?.from?.name,
                                    fromAddress:item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.address : item?.from?.address,
                                    link: item?.form?.link,
                                    tx_proof:item?.tx_proof,
                                    // fromAddress:item?.from?.address,
                                    // toAddress:item?.to?.address,
                                    authProofUrl: res?.data?.viewInIpfs 

                                    
                                },

                                eventOccurence: {
                                    date:item?.date
                                },
                                meta: {
                                    ...item?.meta
                                }
                            })
                        }),
                        nftSMProvenance : _data?.nftProvenance?.map((item) => {
                            return {
                                data: [
                                    {
                                        tag: item?.from?.name ?? item?.to?.name,
                                        title: item?.title,
                                        subtitle: item?.from?.name ?? item?.to?.name,
                                        link: item?.form?.link,
                                         price: item?.meta?.priceInFiat ?? item?.meta?.priceInCrypto ,
                                        date: item?.date,
                                        tx_proof:item?.tx_proof,
                                        fromAddress:item?.from?.address,
                                        toAddress:item?.to?.address,
                                        authProofUrl: res?.data?.viewInIpfs 

                                    },
                                ],
                            };
                        }),
                    };
                    console.log("catt", _found);
                    if (_found) {
                        return _found;
                    }
                }
                log.success(MODULE_NAME, "get asset detail result: ", res);
                // // return res?.data?.getAssets;
                // return res?.data?.getAsset;
            }
        } catch (err) {
            getErrorMessage(err);
        }
    }

    async editAssetDetail(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data in service`, formData);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPDATE_ASSET_DETAIL,
                    variables: formData,
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "update asset: ", res);
                return res?.data;
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async editDuplicateAsset(formData: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `data edit duplicate in service`, formData);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPDATE_DUPLICATE_ASSET,
                    variables: {input:formData},
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "update duplicate asset: ", res);
                return res?.data;
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async listAssetService(data: any) {
        const terms = AssetDetailService.getInstance();
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAssetdata in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LIST_ASSET_IN_CRYPTO,
                    variables: {
                        input: data,
                        tosInput:{
                            type:"asset_list",
                            agreementUrl: terms?.termsURL
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "LIIST ASSET: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async getVoucherFiat(data: any, auth:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAsset voucher`, data);
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_VOUCHER,
                    variables: {
                        auth: {
                            signature: auth?.result?.result,
                            expected_address: auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                            walletName:auth?.walletName
                        },
                        input: {
                            tokenId: data?.tokenId,
                            tokenGroup: data?.tokenGroup,
                            // store: data?.storeId,
                            price: data?.price,
                            type:"fiat"
                        }
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "LIST ASSET: ", res);
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async getVoucherCrypto(data: any, auth:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAsset voucher`, auth);
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_VOUCHER,
                    variables: {
                        auth:{
                            signature: auth?.result?.result,
                            expected_address: auth?.result.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                            walletName:auth?.walletName
                        },
                        input: {
                            tokenId: data?.tokenId,
                            tokenGroup: data?.tokenGroup,
                            // store: data?.storeId,
                            price: data?.price,
                            type:"crypto"
                        }
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "LIST ASSET: ", res);
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async sendSignedVoucherCrypto(data:any, signedobj:any){
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAssetdata in service`, signedobj);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LIST_ASSET_IN_CRYPTO,
                    variables: {
                        input: {
                            ...data,
                            voucher:signedobj?.value?.voucher
                        },
                        auth:{
                            signature: signedobj?.value?.auth?.result?.result,
                            expected_address: signedobj?.value?.auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE, 
                            walletName: signedobj?.value?.auth?.walletName
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "LIST ASSET: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async selfTransfer(data:any, signedobj?:any){
        const terms = AssetDetailService.getInstance();
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAssetdata in service`, signedobj);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: SELF_TRANSFER,
                    variables: {
                        input: {
                            tokenId:data?.tokenId,
                            tokenGroup:data?.tokenGroup,
                            voucher:signedobj?.value?.voucher
                        },
                        auth:{
                            signature: signedobj?.value?.auth?.result?.result,
                            expected_address: signedobj?.value?.auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE, 
                            walletName: signedobj?.value?.auth?.walletName
                        },
                        tosInput:{
                            type:"asset_self_transfer",
                            agreementUrl: terms?.termsURL 
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "Self Transfer: ", res);
                if (res?.data?.selfTransfer) {
                    return res?.data?.selfTransfer;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }
    async lockAssetOnTxSuccess(data:any, signedobj?:any){
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAssetdata in service`, signedobj);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LOCK_ON_TX_SUCCESS,
                    variables: {
                        input: {
                            tokenId:data?.tokenId,
                            tokenGroup:data?.tokenGroup,
                            hash:signedobj?.value?.txResult?.txHash
                        },
                        auth:{
                            signature: signedobj?.value?.auth?.result?.result,
                            expected_address: signedobj?.value?.auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE, 
                            walletName: signedobj?.value?.auth?.walletName
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "Self Transfer: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async listAssetFiat(data: any) {
        const terms = AssetDetailService.getInstance();
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAssetdata in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LIST_ASSET_IN_FIAT,
                    variables: {
                        input: data,
                        tosInput:{
                            type:"asset_list",
                            agreementUrl: terms?.termsURL
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "LIST ASSET: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async sendSignedVoucherFiat(data: any, signedobj:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `listAssetdata in service`, signedobj);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LIST_ASSET_IN_FIAT,
                    variables: {
                        input: {
                            ...data,
                            voucher:signedobj?.value?.voucher
                        },
                        auth:{
                            signature: signedobj?.value?.auth?.result?.result,
                            expected_address: signedobj?.value?.auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE, 
                            walletName:signedobj?.value?.auth?.walletName
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "LIST ASSET: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async showcaseAsset(data: any) {
        const terms = AssetDetailService.getInstance();
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `showcaseAsset in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: SHOWCASE_ASSET,
                    variables: {
                        input: data,
                        tosInput: {
                            type:"asset_display_for_claim",
                            agreementUrl: terms?.termsURL 
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "SHOWCASE ASSET: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async sendSignedVoucherSelfTransfer(data: any, signedobj:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `self transfer in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    // mutation: SHOWCASE_ASSET,
                    variables: {
                        input: {
                            ...data,
                            voucher:signedobj?.value?.voucher
                        },
                        auth:{
                            signature: signedobj?.value?.auth?.result?.result,
                            expected_address: signedobj?.value?.auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE, 
                            walletName: signedobj?.value?.auth?.walletName
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "SHOWCASE ASSET: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async sendSignedVoucherShowcase(data: any, signedobj:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `showcaseAsset in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: SHOWCASE_ASSET,
                    variables: {
                        input: {
                            ...data,
                            voucher:signedobj?.value?.voucher
                        },
                        auth:{
                            signature: signedobj?.value?.auth?.result?.result,
                            expected_address: signedobj?.value?.auth?.result?.params[1],
                            message: SIGN_VOUCHER_MESSAGE, 
                            walletName: signedobj?.value?.auth?.walletName
                        }
                    },
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "SHOWCASE ASSET: ", res);
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    _getStoreFormData(data: any, categories: any, networks: any) {
        // console.log("store-front-data-service", data);
        let _initialStoreOptions =
            data &&
            Array.isArray(data) &&
            data.map((item, index) => {
                if (item?.name) {
                    return {
                        label: item?.name,
                        value: item?.id,
                    };
                }
            });
        let _initialCategoriesOption: any = [];
        _initialCategoriesOption =
            categories &&
            Array.isArray(categories) &&
            categories.map((item: any, index: number) => {
                if (item) {
                    return {
                        label: item && humanize(item),
                        value: item,
                    };
                }
            });

        let _networkOptions =
            networks &&
            Array.isArray(networks) &&
            networks.map((item, index) => {
                return {
                    label: item && humanize(item),
                    value: item,
                };
            });

        let result = LIST_ASSET_FORM_DATA.map((item, index) => {
            // console.log("listing FORM",item)
            if (item?.name === "selectStorefront") {
                return {
                    ...item,
                    fieldProps: {
                        ...item?.fieldProps,
                        initialOptions: _initialStoreOptions
                            ? _initialStoreOptions
                            : [],
                    },
                };
            } else if (item?.name === "selectCategory") {
                return {
                    ...item,
                    fieldProps: {
                        ...item?.fieldProps,
                        initialOptions: _initialCategoriesOption,
                    },
                };
            } else if (item?.name === "selectNetwork") {
                return {
                    ...item,
                    fieldProps: {
                        ...item?.fieldProps,
                        initialOptions: _networkOptions,
                    },
                };
            } else {
                return {
                    ...item,
                };
            }
        });
        return result;
    }

    // async selfTransfer(data: any) {
    //     const graphqlModule = getGraphQLModule();
    //     const client = graphqlModule.getClient("graphql-gateway");
    //     log.blue(MODULE_NAME, `selfTransfer in service`, data);
    //     try {
    //         if (client) {
    //             const res = await client.mutate({
    //                 // mutation: SELF_TRANSFER,
    //                 variables: {
    //                     input: data,
    //                 },
    //                 fetchPolicy: "no-cache",
    //             });
    //             log.success(MODULE_NAME, "SELF TRANSFER ASSET: ", res);
    //             if (res) {
    //                 return res;
    //             }
    //         }
    //     } catch (err: any) {
    //         err?.graphQLErrors &&
    //             Array.isArray(err?.graphQLErrors) &&
    //             err?.graphQLErrors.length > 0 &&
    //             toast.error(err?.graphQLErrors[0]?.message);
    //     }
    // }

    _getStoreFormShowcaseData(data: any, categories: any, networks: any) {
        let _initialStoreOptions =
            data &&
            Array.isArray(data) &&
            data.map((item, index) => {
                if (item?.name) {
                    return {
                        label: item?.name,
                        value: item?.id,
                    };
                }
            });
        let _initialCategoriesOption: any = [];
        _initialCategoriesOption =
            categories &&
            Array.isArray(categories) &&
            categories.map((item: any, index: number) => {
                if (item) {
                    return {
                        label: item && humanize(item),
                        value: item,
                    };
                }
            });
        let _networkOptions =
            networks &&
            Array.isArray(networks) &&
            networks.map((item, index) => {
                return {
                    label: item && humanize(item),
                    value: item,
                };
            });

        let result = SHOWCASE_ASSET_FORM_DATA.map((item, index) => {
            if (item?.name === "selectStorefront") {
                return {
                    ...item,
                    fieldProps: {
                        ...item?.fieldProps,
                        initialOptions: _initialStoreOptions
                            ? _initialStoreOptions
                            : [],
                    },
                };
            } else if (item?.name === "selectCategory") {
                return {
                    ...item,
                    fieldProps: {
                        ...item?.fieldProps,
                        initialOptions: _initialCategoriesOption,
                    },
                };
            } else if (item?.name === "selectNetwork") {
                return {
                    ...item,
                    fieldProps: {
                        ...item?.fieldProps,
                        initialOptions: _networkOptions,
                    },
                };
            } else {
                return {
                    ...item,
                };
            }
        });
        return result;
    }

    async getStorefront(payload: any) {
        log.success(`payload in service:`, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                if (payload?.storeId) {
                    const res = await client.query({
                        query: GET_STORES_WITH_ID,
                        variables: {
                            storeId: payload?.storeId,
                            size: 10,
                            offset: 0,
                        },
                        fetchPolicy: "network-only",
                    });
                    if (res?.data) {
                        return {
                            LIST_ASSET_FORM_DATA: this._getStoreFormData(
                                res?.data?.findStore?.data,
                                res?.data?.getCategoriesByStore?.categories,
                                res?.data?.getSupportedNetworks
                            ),
                            LIST_ASSET_FIELDS,
                            LIST_ASSET_FIELDS_FIAT,
                            SHOWCASE_ASSET_FORM_DATA:
                                this._getStoreFormShowcaseData(
                                    res?.data?.findStore?.data,
                                    res?.data?.getCategoriesByStore?.categories,
                                    res?.data?.getSupportedNetworks
                                ),
                            SHOWCASE_ASSET_FIELDS,
                        };
                    }
                } else {
                    const res = await client.query({
                        query: GET_STORES,
                        variables: {
                            size: 10,
                            offset: 0,
                        },
                        fetchPolicy: "network-only",
                    });
                    if (res?.data) {
                        return {
                            LIST_ASSET_FORM_DATA: this._getStoreFormData(
                                res?.data?.findStore?.data,
                                [],
                                []
                            ),
                            LIST_ASSET_FIELDS,
                            LIST_ASSET_FIELDS_FIAT,
                            SHOWCASE_ASSET_FORM_DATA:
                                this._getStoreFormShowcaseData(
                                    res?.data?.findStore?.data,
                                    [],
                                    []
                                ),
                            SHOWCASE_ASSET_FIELDS,
                        };
                    }
                }
            }
        } catch (err) {
            getErrorMessage(err);
            return {
                LIST_ASSET_FIELDS,
                LIST_ASSET_FIELDS_FIAT,
                LIST_ASSET_FORM_DATA,
                SHOWCASE_ASSET_FORM_DATA,
                SHOWCASE_ASSET_FIELDS,
            };
        }
    }
}
